import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AddTransactionManualy = (props) => {
  const [date, setDate] = useState("");
  const [ammount, setAmmount] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleAmmountChange = (e) => {
    setAmmount(e.target.value);
  };

  const addTransaction = async () => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        date: date,
        client: props.client.petitioner + " | " + props.client.id,
        title: "Dodano ręcznie przez " + props.user,
        bank_acc: "",
        tr_id: new Date().valueOf(),
        bank: "",
        bill: ammount,
        payId: props.id,
        reason: "",
        assign_date:
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate()),
        checked: "",
        note: "",
      };

      await fetch("https://apidevkppp.ftpeople.pl/insertTransactionsAssigned", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "transakcję manualnie",
          }).then((result) => {
            props.close();
          });
          return;

          var body = {};
          await fetch(
            "https://apidevkppp.ftpeople.pl/getTransactionsAssigned",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              checkPayments(data);
            })
            .catch((error) => {});
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkPayments = async (transactions) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data
          .filter((el) => !el.archive_date)
          .map(async (el) => {
            var transactionsForPayment = transactions.filter(
              (tr) => tr.payId === el.identifier
            );
            transactionsForPayment.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
            var pay_sum = 0;
            for (var i = 0; i < transactionsForPayment.length; i += 1) {
              pay_sum =
                parseFloat(
                  transactionsForPayment[i].bill.replaceAll(",", ".")
                ) + pay_sum;
            }

            var archive =
              parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
            var bankAcc = el.bank_acc;
            if (transactionsForPayment.length > 0) {
              if (
                !transactionsForPayment[0].title.includes("Wpłata w UP") &&
                !transactionsForPayment[0].client.includes("CINKCIARZ")
              ) {
                bankAcc = transactionsForPayment[0].bank_acc;
              }
            }

            var body2 = {
              identifier: el.identifier,
              pay_sum: pay_sum,
              bank_acc: bankAcc,
              pay_count: transactionsForPayment.length,
              pay_expected_count: checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ),
              last_pay_date:
                transactionsForPayment.length > 0
                  ? transactionsForPayment[0].date
                  : "",
              is_overdated:
                checkExpectedTransactionsCount(
                  el.first_payment_date,
                  el.installment
                ) > transactionsForPayment.length
                  ? "TAK"
                  : "NIE",
              to_archive:
                parseInt(el.to_settlement.toString().replace(",", ".")) ===
                parseInt(pay_sum.toString().replace(",", "."))
                  ? "TAK"
                  : "NIE",
              delay_time:
                archive === "TAK"
                  ? 0
                  : getDelayTime(
                      el.first_payment_date,
                      transactionsForPayment.length,
                      checkExpectedTransactionsCount(
                        el.first_payment_date,
                        el.installment
                      )
                    ),
            };

            await fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          });
      })
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Dodano",
      text: "transakcję manualnie",
    }).then((result) => {
      props.close();
    });
  };

  const validatePayment = (e) => {
    if (date.length > 0 && ammount.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  return (
    <>
      <div className="mainContainerChangeTransaction">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>

            <div id="addPaymentIC" className="inputContainer">
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>
                    Data <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="date"
                    id="name"
                    name="name"
                    value={date}
                    onChange={handleDateChange}
                  />
                </div>
                <div className="inputCol_3">
                  <label>
                    Kwota rozliczenia <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    id="name"
                    name="name"
                    value={ammount}
                    onChange={handleAmmountChange}
                  />
                </div>
              </div>
              <div className="saveBoxAP">
                <button className="paymentMenuButton" onClick={addTransaction}>
                  zapisz
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddTransactionManualy;
